function nonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

/**
 * Initial caption for a published carousel: the clip's generated copy
 * (`clip.copy.result.description`, then its first `title_list` entry), else
 * the first slide's text. `copyResult` is untyped JSON, so every field is
 * validated. Capped at `maxLength` when given.
 */
export function resolveCarouselCaption(args: {
  copyResult: unknown;
  slides: ReadonlyArray<{ text: string }>;
  maxLength?: number;
}): string {
  const { copyResult, slides, maxLength } = args;
  let caption: string | null = null;
  if (copyResult && typeof copyResult === 'object' && !Array.isArray(copyResult)) {
    const copy = copyResult as { description?: unknown; title_list?: unknown };
    caption = nonEmptyString(copy.description)
      ?? (Array.isArray(copy.title_list) ? nonEmptyString(copy.title_list[0]) : null);
  }
  caption = caption ?? nonEmptyString(slides[0]?.text) ?? '';
  return maxLength !== undefined ? caption.slice(0, maxLength) : caption;
}
